import styled from "styled-components";
import { Grid, Button } from "@material-ui/core";

export const PendingReviewsRootGrid = styled(Grid)`
  padding-bottom: 24px;
`;

export const PendingReviewsTitleText = styled.div`
  padding-bottom: 4px;
`;

export const ExportAndFilterRootGrid = styled(Grid)`
  && {
    display: flex;
    padding: none;
  }
`;

export const ButtonExportRootGrid = styled(Grid)`
  display: flex;
  align-items: center;
`;

export const ButtonExport = styled(Button)`
  && {
    text-transform: none;
    padding-top: 4px;
    padding-bottom: 4px;
    fon-size: 10px;
    text-decoration: none;
    font-weight: bold;
    color: #000000;
  }
`;

const styles = () => ({
  buttonExport: {
    textTransform: 'none',
    paddingTop: '4px',
    paddingBottom: '4px',
    fontSize: '10px',
    textDecoration: 'none',
    fontWeight: 'bold',
    color: '#000000'
  },
});

export default styles;